module.exports = __webpack_public_path__ + "static/media/970x250.d27c06c3.png";